import React, { useState, useEffect, useRef } from 'react';

import DismissableModal from '../DismissableModal';

import { sendAuthenticatedAsyncRequest } from '../../services/AsyncRequestService';

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

import './PawStatus.css';
import { FormSelect } from 'react-bootstrap';

const SubmitForReviewPaw = (props) => {
  const [isCommentValid, setIsCommentValid] = useState(false);
  const [comments, setComments] = useState("");
  const [usersList, setUsersList] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [failure, setFailure] = useState(false);
  const [isUserSelected, setIsUserSelected] = useState(false);
  const modalRef = useRef(null);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = () => {
    sendAuthenticatedAsyncRequest(
      `/paw-group/drug-groups/owners?excludeCurrentUser=true`,
      "GET",
      null,
      (r) => setUsersList(r.data),
      (r) => setFailure(true)
    );
  }

  const submitForReview = () => {
    if (isCommentValid && isUserSelected) {
      props.attemptStatusUpdate(comments, selectedUserId);
      modalRef.current.handleClose();
    }
  }

  const handleUserChange = (e) => {
    setSelectedUserId(e.target.value);
    setIsUserSelected(e.target.value !== "");
  }

  const handleCommentChange = (e) => {
    setComments(e.target.value);
    setIsCommentValid(e.target.value !== "");
  }

  const customFooterContent = (
    <div>
      <Button id='switchdetails-btn-sfr-cancel' variant="outline-dark" onClick={() => modalRef.current.handleClose()}>Cancel</Button>
      <Button
        id='switchdetails-btn-sfr'
        className="left-spacer"
        variant="warning"
        onClick={submitForReview}>
        Yes, submit this for review
      </Button>
    </div>
  );
  return (
    <DismissableModal
      ref={modalRef}
      customFooterContent={customFooterContent}
      openModalButtonText="Submit for Review"
      openModalButtonStyle="info"
      openModalButtonBlock={true}
      openModalButtonDisabled={props.disallowEditing}
      openModalButtonId='switchdetails-btn-sfr-popup'
      openModalButtonClassName="btn-block"
      title="Submit Switch for Review" >
      <p className="confirmation-text">
        You have selected to <b>submit</b> this Drug Group for review.
      </p>
      <p className="text-muted">Once you submit this Drug Group for review, the reviewer will claim this Drug Group and would be able to change its status.</p>
      {
        usersList.length === 0
          ? failure
            ? <p className="text-danger"> Failed to load Reviewers</p> : <p className="text-info"> Loading Reviewers ...</p>
          : <Form.Group >
            <Form.Label>Select Reviewer</Form.Label>
            <FormSelect
              id='switchdetails-select-sfr-reviewer'
              value={selectedUserId}
              onChange={handleUserChange}
            >
              <option value="">Click to select a Reviewer</option>
              {
                usersList.map((u, k) => <option value={u.id} key={k} id={`switchdetails-user-id-${u.id}`}>{u.name}</option>)
              }
            </FormSelect>
            {
              !isUserSelected ? <span className="text-danger smaller-feedback">Selecting a Reviewer is mandatory!</span> : <span className="text-success smaller-feedback">Looks good!</span>
            }
          </Form.Group>

      }
      <Form.Group>
        <Form.Label>Please enter comments for reviewer</Form.Label>
        <Form.Control
          id='switchdetails-textarea-sfr-comments'
          as="textarea"
          rows="3"
          value={comments}
          onChange={handleCommentChange} />
        {
          !isCommentValid ? <span className="text-danger smaller-feedback">Comments are mandatory!</span> : <span className="text-success smaller-feedback">Looks good!</span>
        }
      </Form.Group>
    </DismissableModal>
  );
}

export default SubmitForReviewPaw;
